// @flow

import { /* APP_CONFIG, */ CAN_USE_DOM } from 'common/constants';
import _ from 'lodash';
import { SHARE_CONSTANTS } from 'client/constants/common';
import { Responsive } from 'client/components/common/Responsive';

export const share = (
	type: string,
	options?: {
		description?: string,
		shareType?: string,
		shareItemId?: string,
		itemShareDescription?: string,
		itemShareTitle?: string,
		inHeaderLocated?: boolean,
		inContentLocated?: boolean,
		generalShareTitle?: string,
	},
	cb: Function = _.noop
) => {
	if (!CAN_USE_DOM) {
		return;
	}

	// const domain = `${APP_CONFIG.domains.client.hostname}`;
	let url;
	if (options?.shareItemId) {
		const domainUrl = window.location.href.split('?')[0];
		url = `${domainUrl}?shareItemId=${options?.shareItemId ? options.shareItemId : ''}`;
	} else {
		url = `${window.location.href}`;
	}
	const domain = url;
	// const titleProp = CAN_USE_DOM ? document.querySelector('meta[property="og:title"]') : null;
	// let title: ?string = titleProp ? titleProp.getAttribute('content') : '';
	let title;

	// Title for whatsapp is used shares from result form or from header
	if ((options?.inHeaderLocated || options?.inContentLocated) && options?.generalShareTitle) {
		title = options.generalShareTitle;
	}

	// Title for whatsapp if used shares from item in horizontal checklist
	if (options?.shareItemId && options?.itemShareTitle) {
		title = options?.itemShareTitle;
	}
	const descriptionProp = CAN_USE_DOM ? document.querySelector('meta[property="og:description"]') : null;
	let description: ?string = descriptionProp ? descriptionProp.getAttribute('content') : '';
	// const imageProp = CAN_USE_DOM ? document.querySelector('meta[property="og:image"]') : null;
	// const image: ?string = imageProp ? imageProp.getAttribute('content') : '';
	const encode = encodeURIComponent;
	const mail = '';

	if (options?.shareType === 'custom' && options?.description) {
		description = options?.description;
	}

	// Description for whatsapp if used shares from item in horizontal checklist
	if (options?.itemShareDescription && options?.shareItemId) {
		description = options?.itemShareDescription;
	}

	if (type === SHARE_CONSTANTS.FACEBOOK) {
		const fbURL = 'https://www.facebook.com/sharer.php?u=';

		window.open(`${fbURL}${encode(domain)}`, 'sharer', 'width=555,height=600');
	}

	if (type === SHARE_CONSTANTS.WHATSAPP) {
		console.info('====TITLE====', title);
		if (title && description) {
			if (Responsive.isMatching(Responsive.DESKTOP)) {
				window.open(
					`https://web.whatsapp.com/send?text=${encode(`${title}\n${description}\n${domain}`)}`,
					'_blank'
				);
			} else {
				window.location.href = `whatsapp://send?text=${encode(`${title}\n${description}\n${domain}`)}`;
			}
		}
	}

	if (type === SHARE_CONSTANTS.EMAIL) {
		if (title && description && domain) {
			window.location.href = `mailto:${mail}?subject=${encode(title)}&body=${description}\n\n ${domain}`;
		}
	}

	cb();
};
